<template>
  <div>
    <page-header header="Manually company" />
    <create-form
      @submit="create"
      :error="error"
      v-model="company"
    >
      <div class="w-100 mt-4 py-4 d-flex border-top">
        <button
          class="ml-auto btn btn-primary "
        >
          Create
        </button>
      </div>
    </create-form>
  </div>
</template>

<script>
import CreateForm from './Form'
import axios from '@/axios'
import {successNotification} from '@/notifications'

export default {
  components: {
    CreateForm,
  },

  data () {
    return {
      error: null,
      company: {},
    }
  },

  async created () {
    if (this.$route.params.suggestionId) {
      const {data} = await axios.get(`/companies/suggestions/${this.$route.params.suggestionId}`)
      this.company = data.data
    }
  },

  methods: {
    created (response) {
      this.$router.replace({name: 'companies.view', params: {companyId: response.data.data.id}})
    },

    async create () {
      try {
        const {data} = await this.$http.post('/companies', this.company)
        this.$notify(successNotification(`Created company ${data.data.name}`))
        this.$router.replace({name: 'companies.view', params: {companyId: data.data.id}})
      } catch (e) {
        this.error = e.response.data
      }
    },
  },
}
</script>
